import { Dictionary, groupBy } from 'lodash'
import { Project_Goal_Feature } from 'src/@types/graphql'
import { FEATURE_TYPE_CODE_TYPE } from 'src/shared/constants/feature-constants'

/**
 * Groups project goal features by the feature type config code.
 *
 * @param {Array<Project_Goal_Feature>} projectGoalFeatures - The list of project goal features to group.
 * @returns {Dictionary<Project_Goal_Feature[]>} - A dictionary where the keys are feature type config codes,
 * and the values are arrays of project goal features belonging to that code.
 */
export const groupProjectGoalFeaturesByCode = (
  projectGoalFeatures: Array<Project_Goal_Feature>,
): Dictionary<Project_Goal_Feature[]> => {
  return groupBy(projectGoalFeatures, (x) => x.feature_value.feature_config.feature_type_config.code)
}

/**
 * Retrieves the project goal features for a specific group code.
 *
 * @param {Dictionary<Project_Goal_Feature[]>} groupedFeatures - The dictionary of grouped project goal features.
 * @param {FEATURE_TYPE_CODE_TYPE} groupCode - The group code to fetch features for.
 * @returns {Array<Project_Goal_Feature>} - An array of project goal features for the specified group code.
 * If the group code does not exist, an empty array is returned.
 */
export const getGoalFeaturesByGroupCode = (
  groupedFeatures: Dictionary<Project_Goal_Feature[]>,
  groupCode: FEATURE_TYPE_CODE_TYPE,
): Array<Project_Goal_Feature> => {
  return groupedFeatures[groupCode] || []
}
